import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-bg--gray--pc c-common-footer-fixed" }
const _hoisted_2 = { class: "c-common-footer-fixed__inner" }
const _hoisted_3 = { class: "c-common-inner" }
const _hoisted_4 = { class: "p-the-page-i03" }
const _hoisted_5 = { class: "p-the-page-i03__inner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_theHeader = _resolveComponent("theHeader")!
  const _component_IInvestedStandardList = _resolveComponent("IInvestedStandardList")!
  const _component_TheTemplateI = _resolveComponent("TheTemplateI")!
  const _component_FloatingGivePointButton = _resolveComponent("FloatingGivePointButton")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_theHeader, { ref: "theHeader" }, null, 512),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_TheTemplateI, {
          heading: _ctx.investedStandardDetail[0]?.name,
          "indicated-item": []
        }, {
          contents: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_IInvestedStandardList, { "invested-standard-detail": _ctx.investedStandardDetail }, null, 8, ["invested-standard-detail"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["heading"])
      ])
    ]),
    _createVNode(_component_FloatingGivePointButton),
    _createVNode(_component_TheFooter)
  ]))
}